import React from 'react';
import './Logs.css';

const DASHBOARD_UID = 'tdq7dgm';
const DASHBOARD_SLUG = 'logs';
const THEME = 'dark';
const FROM = 'now-6h';
const TO = 'now';

const Logs = () => {
  const GRAFANA_BASE = import.meta.env.VITE_API_URL;
  const iframeUrl = `${GRAFANA_BASE}/d/${DASHBOARD_UID}/${DASHBOARD_SLUG}?orgId=1&kiosk&theme=${THEME}&from=${FROM}&to=${TO}`;

  return (
    <div className="logs-container">
      <header className="logs-header">
        <h1>Logs</h1>
      </header>
      <div className="logs-iframe-container">
        <iframe
          src={iframeUrl}
          title="Dashboard Grafana - Logs"
          className="logs-grafana-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default Logs;
